export default function VerticalSeparator() {
    return (
        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 13V1" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 4 4" />
        </svg>
    );
}
